/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ContactMethodType {
  Phone = 'Phone',
  Email = 'Email'
}
